var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.request
        ? _c("PageHeadContainer", {
            attrs: { title: _vm.request[0].job_title },
            scopedSlots: _vm._u(
              [
                {
                  key: "status",
                  fn: function () {
                    return [
                      _c("CardInfoChip", {
                        attrs: { message: _vm.requestStatus },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "icons",
                  fn: function () {
                    return [
                      _c(
                        "PageHeadIcon",
                        { attrs: { content: _vm.period } },
                        [_c("ClockIcon", { staticClass: "h-5 w-5" })],
                        1
                      ),
                      _vm._t("default"),
                      _c(
                        "PageHeadIcon",
                        { attrs: { content: _vm.manager } },
                        [_c("UserIcon", { staticClass: "h-5 w-5" })],
                        1
                      ),
                      _c(
                        "PageHeadIcon",
                        { attrs: { content: _vm.requestTag } },
                        [_c("TagIcon", { staticClass: "h-5 w-5" })],
                        1
                      ),
                      _c(
                        "PageHeadIcon",
                        {
                          attrs: {
                            content: _vm.request[0].number_of_contractors,
                          },
                        },
                        [_c("GroupsIcon", { staticClass: "h-5 w-5" })],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                _vm.isActionsShown
                  ? {
                      key: "actions",
                      fn: function () {
                        return [_c("div", { staticClass: "flex" })]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }